import { RequestReport } from '@/components';

export function RequestReportPage() {
  return <RequestReport />;
}
